var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7278 11.9057C9.39193 12.944 7.71081 13.4338 6.0267 13.2754C4.34259 13.117 2.78213 12.3224 1.66305 11.0533C0.543968 9.78421 -0.0495848 8.13609 0.00324691 6.44452C0.0560786 4.75295 0.751322 3.14512 1.94742 1.94841C3.14351 0.751707 4.75051 0.0561073 6.44122 0.00324857C8.13193 -0.0496101 9.77921 0.544247 11.0476 1.6639C12.3161 2.78355 13.1103 4.34482 13.2686 6.02979C13.4269 7.71476 12.9373 9.39674 11.8996 10.7333L15.7549 14.5761C16.0813 14.9014 16.0818 15.4298 15.756 15.7557C15.4302 16.0816 14.9018 16.0814 14.5763 15.7552L10.7361 11.9057H10.7278ZM6.65533 11.6396C7.31018 11.6396 7.95863 11.5106 8.56364 11.2598C9.16865 11.0091 9.71837 10.6416 10.1814 10.1783C10.6445 9.71503 11.0118 9.16503 11.2624 8.55971C11.513 7.95439 11.642 7.30561 11.642 6.65042C11.642 5.99522 11.513 5.34645 11.2624 4.74113C11.0118 4.13581 10.6445 3.5858 10.1814 3.12251C9.71837 2.65922 9.16865 2.29172 8.56364 2.04099C7.95863 1.79025 7.31018 1.6612 6.65533 1.6612C5.33278 1.6612 4.0644 2.18685 3.12922 3.12251C2.19404 4.05817 1.66867 5.3272 1.66867 6.65042C1.66867 7.97364 2.19404 9.24267 3.12922 10.1783C4.0644 11.114 5.33278 11.6396 6.65533 11.6396Z",
    fill: "#787878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.835744c2650d1bdb382796c0e06b8866.svg";
export { ForwardRef as ReactComponent };